import * as React from "react";
const SvgOneWay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#FFF5F5", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M4.5 12h15m0 0-5.62-6m5.62 6-5.62 6" }));
export default SvgOneWay;
